import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Products.css';

const PRODUCTS = [
  {
    id: 'drink-commercial',
    title: 'Lumina Citrus Splash — 30s Beverage Commercial',
    category: 'commercials',
    industry: 'food-drinks',
    typeLabel: '30s Commercial',
    industryLabel: 'Food & Drinks',
    image: '/images/products/drink_commercial.jpg',
    price: '$1,450',
    priceSubtext: 'Full Brand Customization Included',
    badge: 'Popular Broadcast',
    description: 'High-octane 30-second commercial featuring ultra-realistic 3D fluid dynamics, ice splash collisions, and energetic sound design. Perfect for soda, energy drink, or beverage brand launches.',
    specs: {
      duration: '30 Seconds (15s & 6s cuts available)',
      resolution: '4K Ultra HD (3840x2160) @ 60fps',
      formats: 'ProRes 422 HQ, MP4 (H.264/H.265), Vertical 9:16 Social Cut',
      audio: 'Original sound design, sonic splash effects & broadcast license',
      customization: 'Replace bottle label, color scheme, logo & end-card CTA'
    }
  },
  {
    id: 'food-commercial',
    title: 'Artisan Flame Burger — 30s Gourmet Food Spot',
    category: 'commercials',
    industry: 'food-drinks',
    typeLabel: '30s Commercial',
    industryLabel: 'Food & Drinks',
    image: '/images/products/food_commercial.jpg',
    price: '$1,650',
    priceSubtext: 'Turnkey Commercial Package',
    badge: 'CGI Culinary',
    description: 'Cinematic slow-motion 3D culinary explosion with sizzling patties, melting aged cheese, flying sesame seeds, and grill smoke. Ideal for restaurants, fast-casual franchises, and food delivery campaigns.',
    specs: {
      duration: '30 Seconds (Broadcast & Social variants)',
      resolution: '4K UHD Cinema Scope',
      formats: 'ProRes 4444 with Alpha, 16:9 & 9:16 vertical reels',
      audio: 'Sizzling ASMR sound effects, high-energy soundtrack & voiceover sync',
      customization: 'Custom ingredient swapping, restaurant branding & discount overlays'
    }
  },
  {
    id: 'lawyer-commercial',
    title: 'Apex Legal Partners — 30s Attorney Brand Commercial',
    category: 'commercials',
    industry: 'law-firm',
    typeLabel: '30s Commercial',
    industryLabel: 'Attorney / Law Firm',
    image: '/images/products/lawyer_commercial.jpg',
    price: '$1,850',
    priceSubtext: 'Broadcast & Cable TV Ready',
    badge: 'High Prestige',
    description: 'Sophisticated 30-second broadcast commercial engineered for trial lawyers, corporate counsel, and litigation firms. Features an executive corner office skyline, dynamic lighting, and authoritative tone.',
    specs: {
      duration: '30 Seconds (with 15s TV bumper)',
      resolution: '4K Broadcast Standard (Clearance Ready)',
      formats: 'Broadcast MXF, ProRes, Web MP4',
      audio: 'Authoritative voiceover mix, orchestral legal score, stereo & 5.1 surround',
      customization: 'Firm name, phone number, attorney photos, practice areas & disclaimers'
    }
  },
  {
    id: 'courtroom-commercial',
    title: 'Trial Tech 3D — Courtroom & Litigation Animation',
    category: 'commercials',
    industry: 'law-firm',
    typeLabel: '30s Commercial',
    industryLabel: 'Attorney / Law Firm',
    image: '/images/products/courtroom_commercial.jpg',
    price: '$2,200',
    priceSubtext: 'Courtroom & Marketing Dual-Use',
    badge: 'Litigation FX',
    description: 'Demonstrative legal presentation and marketing reel demonstrating 3D holographic accident reconstruction and impact telemetry. Built for personal injury attorneys and forensic courtroom presentations.',
    specs: {
      duration: '30 to 60 Seconds custom timeline',
      resolution: '4K Ultra HD 60fps',
      formats: 'MP4, MOV, PowerPoint/TrialDirector compatible',
      audio: 'Narrative presentation track with sound design',
      customization: 'Custom speed data, vehicular assets, telemetry overlays & firm branding'
    }
  },
  {
    id: 'asset-cocktail-3d',
    title: 'Smoked Crystal Coupe & Beverage 3D Model Asset',
    category: '3d-files',
    industry: 'food-drinks',
    typeLabel: '3D Files',
    industryLabel: 'Food & Drinks',
    image: '/images/products/asset_cocktail_3d.jpg',
    price: '$149',
    priceSubtext: 'Instant Download • Royalty-Free',
    badge: 'Unreal 5 & Unity Ready',
    description: 'Master-level 3D cocktail glass asset with illuminated ice refraction, wispy smoke volumes, and orange twist garnish. Delivered with clean quad topology and photorealistic 4K PBR shaders.',
    specs: {
      polycount: '48,912 Triangles / 24,500 Quads',
      formats: '.FBX, .OBJ, .GLTF / .GLB, Blender (.blend)',
      textures: '4K PBR (Albedo, Roughness, Normal, Metallic, Glass Refraction)',
      compatibility: 'Unreal Engine 5 (Nanite/Lumen), Unity HDRP, Maya, 3ds Max',
      license: 'Commercial Royalty-Free Lifetime License'
    }
  },
  {
    id: 'asset-gavel-3d',
    title: 'Scales of Justice & Judicial Gavel 3D Asset Pack',
    category: '3d-files',
    industry: 'law-firm',
    typeLabel: '3D Files',
    industryLabel: 'Attorney / Law Firm',
    image: '/images/products/asset_gavel_3d.jpg',
    price: '$189',
    priceSubtext: 'Instant Download • Royalty-Free',
    badge: 'High-Detail PBR',
    description: 'Pristine 3D legal model kit featuring brass balance scales, engraved details, and a polished walnut judicial gavel with sound block. Perfect for legal tech apps, metaverse offices, and high-res renders.',
    specs: {
      polycount: '138,400 Triangles (Subdivision-Ready)',
      formats: '.FBX, .OBJ, .GLB, .USDZ (Apple AR), Cinema 4D, Blender',
      textures: '4K PBR High-Gloss Brass & Walnut Wood Grain Maps',
      compatibility: 'WebXR, Three.js, Unreal Engine, Blender, Apple Vision Pro AR',
      license: 'Commercial Royalty-Free Lifetime License'
    }
  }
];

function Products() {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [activeModalProduct, setActiveModalProduct] = useState(null);
  const navigate = useNavigate();

  const filteredProducts = PRODUCTS.filter((product) => {
    const matchesFilter =
      selectedFilter === 'all' ||
      product.category === selectedFilter ||
      product.industry === selectedFilter;

    const matchesSearch =
      searchQuery.trim() === '' ||
      product.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.industryLabel.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.typeLabel.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesFilter && matchesSearch;
  });

  const handleInquire = (product) => {
    navigate('/animation-quote', {
      state: {
        productTitle: product.title,
        productCategory: product.typeLabel,
        industry: product.industryLabel
      }
    });
  };

  return (
    <div className="products-page">
      {/* Top Breadcrumb & Home Link */}
      <nav className="products-breadcrumb">
        <Link to="/" className="back-home-link">
          ← Back to ThrillArts Home
        </Link>
        <div className="breadcrumb-links">
          <Link to="/animation">Animation Services</Link>
          <Link to="/paintings">Paintings</Link>
          <Link to="/virtual-tours">Virtual Tours</Link>
          <Link to="/contact-us">Contact</Link>
        </div>
      </nav>

      {/* Hero Header */}
      <header className="products-hero">
        <div className="hero-glow-badge">THRILLARTS DIGITAL MARKETPLACE</div>
        <h1 className="products-hero-title">
          3D Files & <span className="gradient-text">30-Second Commercials</span>
        </h1>
        <p className="products-hero-subtitle">
          Engineered for brands, studios, and agencies. Download ready-to-render 3D asset files or order turnkey broadcast-grade 30-second commercials customized for your business.
        </p>

        {/* Search Bar */}
        <div className="products-search-wrapper">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            className="products-search-input"
            placeholder="Search 3D files, 30s commercials, food, drinks, legal..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button className="clear-search-btn" onClick={() => setSearchQuery('')}>
              ✕
            </button>
          )}
        </div>

        {/* Filter Pills */}
        <div className="filter-pills-container">
          <button
            className={`filter-pill ${selectedFilter === 'all' ? 'active' : ''}`}
            onClick={() => setSelectedFilter('all')}
          >
            All Products ({PRODUCTS.length})
          </button>
          <button
            className={`filter-pill ${selectedFilter === '3d-files' ? 'active' : ''}`}
            onClick={() => setSelectedFilter('3d-files')}
          >
            📦 3D Files ({PRODUCTS.filter(p => p.category === '3d-files').length})
          </button>
          <button
            className={`filter-pill ${selectedFilter === 'commercials' ? 'active' : ''}`}
            onClick={() => setSelectedFilter('commercials')}
          >
            🎬 30s Commercials ({PRODUCTS.filter(p => p.category === 'commercials').length})
          </button>
          <button
            className={`filter-pill ${selectedFilter === 'food-drinks' ? 'active' : ''}`}
            onClick={() => setSelectedFilter('food-drinks')}
          >
            🍔 Food & Drinks ({PRODUCTS.filter(p => p.industry === 'food-drinks').length})
          </button>
          <button
            className={`filter-pill ${selectedFilter === 'law-firm' ? 'active' : ''}`}
            onClick={() => setSelectedFilter('law-firm')}
          >
            ⚖️ Attorney / Law Firm ({PRODUCTS.filter(p => p.industry === 'law-firm').length})
          </button>
        </div>
      </header>

      {/* Products Grid */}
      <section className="products-grid-section">
        {filteredProducts.length === 0 ? (
          <div className="no-products-found">
            <h3>No products found matching your search.</h3>
            <p>Try searching for "3D", "commercial", "drink", "burger", or "law".</p>
            <button
              className="btn-reset-filters"
              onClick={() => {
                setSelectedFilter('all');
                setSearchQuery('');
              }}
            >
              Reset All Filters
            </button>
          </div>
        ) : (
          <div className="products-grid">
            {filteredProducts.map((product) => (
              <article key={product.id} className="product-card">
                <div className="product-media-container">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="product-image"
                    loading="lazy"
                  />
                  <div className="media-overlay">
                    <button
                      className="btn-overlay-quickview"
                      onClick={() => setActiveModalProduct(product)}
                    >
                      Quick View & Specs
                    </button>
                  </div>
                  <div className="product-badges">
                    <span className={`badge-pill badge-${product.category}`}>
                      {product.typeLabel}
                    </span>
                    <span className="badge-pill badge-industry">
                      {product.industryLabel}
                    </span>
                  </div>
                  {product.badge && (
                    <span className="badge-highlight">{product.badge}</span>
                  )}
                </div>

                <div className="product-content">
                  <h2 className="product-title">{product.title}</h2>
                  <p className="product-description">{product.description}</p>

                  <div className="product-spec-highlights">
                    {product.specs.duration && (
                      <div className="spec-item">
                        <span className="spec-label">Duration:</span>
                        <span className="spec-val">{product.specs.duration}</span>
                      </div>
                    )}
                    {product.specs.polycount && (
                      <div className="spec-item">
                        <span className="spec-label">Geometry:</span>
                        <span className="spec-val">{product.specs.polycount}</span>
                      </div>
                    )}
                    <div className="spec-item">
                      <span className="spec-label">Formats:</span>
                      <span className="spec-val">
                        {product.specs.formats.length > 32
                          ? product.specs.formats.substring(0, 32) + '...'
                          : product.specs.formats}
                      </span>
                    </div>
                  </div>

                  <div className="product-footer-bar">
                    <div className="price-box">
                      <span className="price-amount">{product.price}</span>
                      <span className="price-note">{product.priceSubtext}</span>
                    </div>

                    <div className="card-btn-group">
                      <button
                        className="btn-card-details"
                        onClick={() => setActiveModalProduct(product)}
                      >
                        Details
                      </button>
                      <button
                        className="btn-card-action"
                        onClick={() => handleInquire(product)}
                      >
                        {product.category === '3d-files' ? 'Download / License' : 'Get Custom Cut'}
                      </button>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>

      {/* Production & Custom Request Banner */}
      <section className="custom-banner-section">
        <div className="custom-banner-card">
          <div className="custom-banner-content">
            <span className="banner-kicker">NEED A CUSTOM BUILD?</span>
            <h2>Custom 3D Assets & Tailored 30s Commercial Campaigns</h2>
            <p>
              Looking for proprietary 3D files for your game or interactive web app? Or need a custom-scripted 30-second commercial with 3D product rendering, CGI food physics, or attorney trial simulations? Our studio delivers end-to-end production.
            </p>
            <div className="banner-actions">
              <Link to="/animation-quote" className="btn-banner-primary">
                Request a Custom Commercial Quote
              </Link>
              <Link to="/contact-us" className="btn-banner-secondary">
                Contact Studio Team
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Product Detail Modal */}
      {activeModalProduct && (
        <div className="modal-backdrop" onClick={() => setActiveModalProduct(null)}>
          <div
            className="modal-card"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <button
              className="modal-close-btn"
              onClick={() => setActiveModalProduct(null)}
              aria-label="Close dialog"
            >
              ✕
            </button>

            <div className="modal-grid">
              <div className="modal-image-col">
                <img
                  src={activeModalProduct.image}
                  alt={activeModalProduct.title}
                  className="modal-image"
                />
                <div className="modal-badges-row">
                  <span className={`badge-pill badge-${activeModalProduct.category}`}>
                    {activeModalProduct.typeLabel}
                  </span>
                  <span className="badge-pill badge-industry">
                    {activeModalProduct.industryLabel}
                  </span>
                </div>
              </div>

              <div className="modal-info-col">
                <span className="modal-tag-highlight">{activeModalProduct.badge}</span>
                <h2 className="modal-title">{activeModalProduct.title}</h2>
                <p className="modal-desc">{activeModalProduct.description}</p>

                <div className="modal-specs-table">
                  <h3>Technical Specifications</h3>
                  <ul>
                    {Object.entries(activeModalProduct.specs).map(([key, value]) => (
                      <li key={key}>
                        <strong className="spec-key">
                          {key.charAt(0).toUpperCase() + key.slice(1)}:
                        </strong>
                        <span className="spec-value">{value}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="modal-pricing-row">
                  <div>
                    <div className="modal-price">{activeModalProduct.price}</div>
                    <div className="modal-price-sub">{activeModalProduct.priceSubtext}</div>
                  </div>

                  <div className="modal-actions">
                    <button
                      className="btn-modal-primary"
                      onClick={() => {
                        const prod = activeModalProduct;
                        setActiveModalProduct(null);
                        handleInquire(prod);
                      }}
                    >
                      {activeModalProduct.category === '3d-files'
                        ? 'License & Download Asset'
                        : 'Order Custom 30s Spot'}
                    </button>
                    <button
                      className="btn-modal-secondary"
                      onClick={() => setActiveModalProduct(null)}
                    >
                      Close Preview
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Products;
